"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAccounts = exports.groupAddAccounts = void 0;
const uniqWith_1 = __importDefault(require("lodash/uniqWith"));
const index_1 = require("@ledgerhq/coin-framework/account/index");
const helpers_1 = require("./helpers");
function sameAccountIdentity(a, b) {
    return (a.id === b.id ||
        (a.freshAddress ? a.currency === b.currency && a.freshAddress === b.freshAddress : false) ||
        (a.xpub ? a.currency === b.currency && a.xpub === b.xpub : false));
}
/**
 * logic that for the Add Accounts sectioned list
 */
function groupAddAccounts(existingAccounts, scannedAccounts, context) {
    const importedAccounts = [];
    const importableAccounts = [];
    const creatableAccounts = [];
    let alreadyEmptyAccount = null;
    const scannedAccountsWithoutMigrate = [...scannedAccounts];
    scannedAccountsWithoutMigrate.forEach(acc => {
        const existingAccount = existingAccounts.find(a => sameAccountIdentity(a, acc));
        if (existingAccount) {
            if (!acc.used && !alreadyEmptyAccount) {
                alreadyEmptyAccount = existingAccount;
            }
            importedAccounts.push(existingAccount);
        }
        else if (!acc.used) {
            creatableAccounts.push(acc);
        }
        else {
            importableAccounts.push(acc);
        }
    });
    const sections = [];
    if (importableAccounts.length) {
        sections.push({
            id: "importable",
            selectable: true,
            defaultSelected: true,
            data: importableAccounts,
        });
    }
    if (!context.scanning || creatableAccounts.length) {
        // NB if data is empty, need to do custom placeholder that depends on alreadyEmptyAccount
        sections.push({
            id: "creatable",
            selectable: true,
            defaultSelected: false,
            data: context.preferredNewAccountSchemes && context.preferredNewAccountSchemes.length > 0
                ? creatableAccounts.filter(a => context.preferredNewAccountSchemes &&
                    // Note: we could use a simple preferredNewAccountScheme param
                    a.derivationMode === context.preferredNewAccountSchemes[0])
                : creatableAccounts,
        });
    }
    if (importedAccounts.length) {
        sections.push({
            id: "imported",
            selectable: false,
            defaultSelected: false,
            data: importedAccounts,
        });
    }
    return {
        sections,
        alreadyEmptyAccount,
    };
}
exports.groupAddAccounts = groupAddAccounts;
const preserveUserData = (update, existing) => (Object.assign(Object.assign({}, update), { name: existing.name }));
function addAccounts({ scannedAccounts, existingAccounts, selectedIds, renamings, }) {
    const newAccounts = [];
    // scanned accounts that was selected
    const selected = scannedAccounts.filter(a => selectedIds.includes(a.id));
    existingAccounts.forEach(existing => {
        // we'll try to find an updated version of the existing account as opportunity to refresh the operations
        const update = selected.find(a => sameAccountIdentity(a, existing));
        if (update) {
            // preserve existing name
            let acc = preserveUserData(update, existing);
            if (update.id !== existing.id) {
                acc = (0, helpers_1.clearAccount)(acc);
            }
            newAccounts.push(acc);
        }
        else {
            newAccounts.push(existing);
        }
    });
    // append the new accounts
    selected.forEach(acc => {
        const alreadyThere = newAccounts.find(a => sameAccountIdentity(a, acc));
        if (!alreadyThere) {
            newAccounts.push(acc);
        }
    });
    // dedup and apply the renaming
    return (0, uniqWith_1.default)(newAccounts, sameAccountIdentity).map(a => {
        const name = (0, index_1.validateNameEdition)(a, renamings[a.id]);
        if (name)
            return Object.assign(Object.assign({}, a), { name });
        return a;
    });
}
exports.addAccounts = addAccounts;
//# sourceMappingURL=addAccounts.js.map